// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* TODO might want to use this layout for some of the other pages */
.user-coordinator .join-page .authentication-action {
    width: 100%;
    padding: 0;
}
.user-coordinator .join-page .join-details {
    display: none;
}

@media (min-width: 768px) {
    .user-coordinator .join-page .authentication-action {
        width: 50%;
        padding: 0;
    }
    .user-coordinator .join-page .form-wrapper {
        margin-top: 0;
    }
    .user-coordinator .join-page .join-details {
        padding-left: 60px;
        align-items: flex-start;
        flex-direction: column;
        justify-content: center;
        display: flex;
        height: 100%;
        padding-top: 0;
        width: 50%;
        height: 100%;
    }

    .user-coordinator .join-page .join-details img {
        display: block;
        height: 80%;
    }

    .user-coordinator .join-page .join-details h1 {
        display: block;
        font-weight: 700;
        color: var(--ce-grey-80);
        padding-bottom: 10px;
    }

    /* ensure page content appears above the image */
    .form-wrapper,
    .authentication-action {
        position: relative;
        z-index: 1;
    }
}`, "",{"version":3,"sources":["webpack://./src/components/Authentication/Coordinator/Join.css"],"names":[],"mappings":"AAAA,mEAAmE;AACnE;IACI,WAAW;IACX,UAAU;AACd;AACA;IACI,aAAa;AACjB;;AAEA;IACI;QACI,UAAU;QACV,UAAU;IACd;IACA;QACI,aAAa;IACjB;IACA;QACI,kBAAkB;QAClB,uBAAuB;QACvB,sBAAsB;QACtB,uBAAuB;QACvB,aAAa;QACb,YAAY;QACZ,cAAc;QACd,UAAU;QACV,YAAY;IAChB;;IAEA;QACI,cAAc;QACd,WAAW;IACf;;IAEA;QACI,cAAc;QACd,gBAAgB;QAChB,wBAAwB;QACxB,oBAAoB;IACxB;;IAEA,gDAAgD;IAChD;;QAEI,kBAAkB;QAClB,UAAU;IACd;AACJ","sourcesContent":["/* TODO might want to use this layout for some of the other pages */\n.user-coordinator .join-page .authentication-action {\n    width: 100%;\n    padding: 0;\n}\n.user-coordinator .join-page .join-details {\n    display: none;\n}\n\n@media (min-width: 768px) {\n    .user-coordinator .join-page .authentication-action {\n        width: 50%;\n        padding: 0;\n    }\n    .user-coordinator .join-page .form-wrapper {\n        margin-top: 0;\n    }\n    .user-coordinator .join-page .join-details {\n        padding-left: 60px;\n        align-items: flex-start;\n        flex-direction: column;\n        justify-content: center;\n        display: flex;\n        height: 100%;\n        padding-top: 0;\n        width: 50%;\n        height: 100%;\n    }\n\n    .user-coordinator .join-page .join-details img {\n        display: block;\n        height: 80%;\n    }\n\n    .user-coordinator .join-page .join-details h1 {\n        display: block;\n        font-weight: 700;\n        color: var(--ce-grey-80);\n        padding-bottom: 10px;\n    }\n\n    /* ensure page content appears above the image */\n    .form-wrapper,\n    .authentication-action {\n        position: relative;\n        z-index: 1;\n    }\n}"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
